<template>
  <div class="wrapper wrapper-content">
    <div class="row">
      <div class="col-12">
        <!-- PDF Viewer Section -->
        <div class="ibox-content">
          {{primarySource}}
          <span v-if="!isFormLoading">
            <div
              v-if="isIcfDocumentLoading"
              class="text-center minheight d-flex align-items-center justify-content-center"
            >
              <div>
                <img
                  src="../../assets/img/loading.gif"
                  width="15"
                  alt="Loading ICF document"
                />
                <div>Loading ICF document</div>
              </div>
            </div>
            <div v-else-if="icfDocumentError" class="minheight col-12 text-center text-muted d-flex align-items-center justify-content-center">
              {{ icfDocumentError }}
            </div>
            <div v-else-if="selectedIcfDocumentSource" class="icf-pdf-viewer icf-document-viewer col-12">
              <vue-pdf-embed
                :source="selectedIcfDocumentSource"
                @error="icfDocumentError = 'Unable to load ICF document'"
              />
            </div>

            <!-- e-Signature Section - Unsigned State -->
            <div v-if="consentformvisible && !disableInput" class="esignature-section col-12">
              <h6>e-Signature</h6>
              <h6>By signing below, I have confirmed:</h6>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="isConsent" value="" id="flexCheckDefault">
                <label class="form-check-label" for="flexCheckDefault">
                  I acknowledge that I have read and comprehended both consent form and the study’s description. I am willingly and voluntarily signing this form as evidence of my decision to participate in this study. I will receive a signed and dated copy of this consent form for my records. By signing this form, I provide consent for the use and disclosure of my health information as stated within the form.
                </label>
                <div class="col-12 col-lg-12 my-2 d-flex justify-content-between">
                  <!-- <label class="col-form-label">Initials</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="Initials"
                    maxlength="2"
                    style="text-transform: uppercase"
                  /> -->
                  <div class="col-md-6">
                  <label class="col-form-label">Email ID</label>
                  <input
                    type="text"
                    v-model="email"
                    class="form-control border-left-important"
                    maxlength="50"
                  />                  
                  <span class="errormsg" v-if="errors[0] == false">Please enter your email ID</span>
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">Password</label>
                    <input
                      type="password"
                      v-model="password"
                      autocomplete="new-password"
                      class="form-control border-left-important"
                      maxlength="50"
                    />
                    <span class="errormsg" v-if="errors[1] == false">{{ $t("navigations.please enter your password") }} </span>
                  </div>
                </div>
                <!-- <div role="button" tabindex="0" @keyup.enter="saveSignData()" class="save_btn col-lg-12 py-2 mt-4" @click.prevent="saveSignData()">Sign</div> -->
              <div class="d-flex justify-content-center">
                <button class="save_btn py-1 px-5 mt-4 " @keyup.enter="saveSignData()" @click.prevent="saveSignData()">Sign</button>
              </div>
              </div>
            </div>

            <!-- e-Signature Section - Signed State -->
            <div v-if="consentformvisible && disableInput" class="esignature-section col-12">
              <h6>e-Signature</h6>
              <h1 class="consentheader">{{ consentdata }}</h1>
              <div :class="{'green-underline': consentdata === 'Consented', 'red-underline': consentdata !== 'Consented'}"></div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="isConsent" :disabled="disableInput" value="">
                <label class="form-label">
                  I acknowledge that I have read and comprehended both consent form and the study’s description. I am willingly and voluntarily signing this form as evidence of my decision to participate in this study. I will receive a signed and dated copy of this consent form for my records. By signing this form, I provide consent for the use and disclosure of my health information as stated within the form.
                </label>
              </div>
              <div class="col-12 col-lg-6 my-2">
                <div class="row">
                  <label class="col-form-label">{{ signinitials }}</label>
                </div>
                <div class="row">
                  <label class="col-form-label">{{ signedBy }}</label>
                </div>
                <div class="row">
                  <label class="col-form-label">Date: {{ filter(signdate) }}</label>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>

    <!-- Signature Popup Modal -->
    <signaturePopUp
      v-if="signpopUp == true"
      :status="signatuestatus"
      :formId="signatureformId"
      :modalText="modalStatus"
      @signatureclosemodel="signpopUp = false"
    />
  </div>
</template>

<script src="./consentFormList.js"></script>

<style scoped>
@import "./modal.css";
@import "../../assets/style.css";
@import "../../assets/formpage.css";

.form-group {
  margin-bottom: 0rem;
}
.minheight {
  height: 400px;
  overflow: auto;
}
.wrapper-content {
  position: relative;
}
.border-left-important {
  border-left: 2px solid #ff6565;
}
.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}
.consentheader {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.green-underline {
  border-bottom: 2px solid rgb(19, 77, 19);
  margin-bottom: 10px;
}
.red-underline {
  border-bottom: 2px solid red;
  margin-bottom: 10px;
}
.save_btn {
  background-color: #059f8c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  display: inline-block;
}
.errormsg {
  color: red;
  font-size: 12px;
}
</style>